import dayjs from "dayjs";
import type { ComponentKey } from "../data/types";

export const RANGE_OPTIONS = [
  { value: "6h", label: "6h" },
  { value: "12h", label: "12h" },
  { value: "18h", label: "18h" },
  { value: "24h", label: "24h" },
  { value: "48h", label: "48h" },
];

export type Period = "last_week" | "last_month" | "last_year";

export const PRESET_DATE_MAP: Record<Period, [dayjs.Dayjs, dayjs.Dayjs]> = {
  last_week: [dayjs().subtract(6, "day"), dayjs()],
  last_month: [dayjs().subtract(29, "day"), dayjs()],
  last_year: [dayjs().subtract(1, "year"), dayjs()],
};

export const COMPONENT_API_MAP: Record<ComponentKey, string> = {
  load: "load",
  pv: "pv",
  gridImport: "grid_import",
  gridExport: "grid_export",
  batteryEnergy: "battery_energy",
  batteryCharge: "battery_charge",
  batteryDischarge: "battery_discharge",
  wind: "wind",
  genset: "genset",
};

export const COMPONENT_LABEL_MAP: Record<ComponentKey, string> = {
  load: "Load",
  pv: "PV",
  gridImport: "Grid Import",
  gridExport: "Grid Export",
  batteryEnergy: "Battery Energy",
  batteryCharge: "Battery Charge",
  batteryDischarge: "Battery Discharge",
  wind: "Wind",
  genset: "Genset",
};
